import React from 'react';

const CollectionsSection = ({ collections }) => {
  return (
    <section id="collections" className="py-20 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-800 mb-4 tracking-wide">
            Our Collections
          </h2>
          <p className="text-neutral-600 tracking-wide">
            Discover thoughtfully curated gifts for every occasion
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {collections.map((collection, index) => (
            <div
              key={index}
              className="group cursor-pointer bg-white overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500"
            >
              <div className="relative overflow-hidden aspect-square">
                <img
                  src={collection.image}
                  alt={collection.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-serif mb-2 tracking-wide text-neutral-800">
                  {collection.title}
                </h3>
                <p className="text-sm text-neutral-600 mb-4">{collection.description}</p>
                <button className="text-sm tracking-widest text-neutral-800 border-b border-neutral-800 hover:text-neutral-600 hover:border-neutral-600 transition-colors duration-300 uppercase">
                  Explore
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollectionsSection;